// src/redux/authApi.js
import { apiSlice } from "./apiSlice";

export const authApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        nicePhoneVerify: build.mutation({
            query: (body) => ({
                url: "/api/user/auth/v1/nice/phone/verify",
                method: "post",
                data: body,
            }),
        }),
        nicePhoneRequest: build.mutation({
            query: (body) => ({
                url: "/api/user/auth/v1/nice/phone/request",
                method: "post",
                data: body,
            }),
        }),
        findPassword: build.query({
            query: ({ login_id, phone }) => ({
                url: "/api/user/auth/v1/find_password",
                method: "get",
                params: { login_id, phone },
            }),
        }),
        findLoginId: build.query({
            query: ({ biz_number, corp_name, phone }) => ({
                url: "/api/user/auth/v1/find_login_id",
                method: "get",
                params: { biz_number, corp_name, phone },
            }),
        }),
        existLoginId: build.query({
            query: ({ login_id }) => ({
                url: "/api/user/auth/v1/exist_login_id",
                method: "get",
                params: { login_id },
            }),
        }),
        existBizNumber: build.query({
            query: ({ biz_number }) => ({
                url: "/api/user/auth/v1/exist_biz_number",
                method: "get",
                params: { biz_number },
            }),
        }),
        authChangePassword: build.mutation({
            query: ({ memberId, password }) => ({
                url: `/api/user/auth/v1/member/${memberId}/change_password`,
                method: "put",
                data: { password },
            }),
        }),
        existPhone: build.query({
            query: ({ phone }) => ({
                url: "/api/user/auth/v1/exist_phone",
                method: "get",
                params: { phone },
            }),
        }),
    }),
});

export const {
    useNicePhoneVerifyMutation,
    useNicePhoneRequestMutation,
    useFindPasswordQuery,
    useLazyFindPasswordQuery,
    useFindLoginIdQuery,
    useLazyFindLoginIdQuery,
    useExistLoginIdQuery,
    useLazyExistLoginIdQuery,
    useExistBizNumberQuery,
    useAuthChangePasswordMutation,
    useExistPhoneQuery,
    useLazyExistPhoneQuery,
} = authApi;
